import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import PagesLayout from 'layout/Pages';

// pages routing
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));

// NOVO: Central de Dispositivos
const DevicesCenter = Loadable(lazy(() => import('pages/security/devices-center')));

// NOVO: Configurações da Conta
const AccountSettings = Loadable(lazy(() => import('pages/account')));
const SettingsIntegrationsPage = Loadable(lazy(() => import('pages/settings/integrations')));

// NOVO: Colaboradores
const UsersPage = Loadable(lazy(() => import('pages/users')));
const SensitiveFieldsPage = Loadable(lazy(() => import('pages/sensitive-fields')));
// NOVO: Funções (roles)
const RolesPage = Loadable(lazy(() => import('pages/roles')));
// NOVO: Teste de Gravação
const RecorderTestPage = Loadable(lazy(() => import('pages/recorder-test')));
// NOVO: Reunião ao vivo (transcrição + tradução em tempo real)
const LiveMeetingPage = Loadable(lazy(() => import('pages/transcriptor/live')));
// NOVO: Departamentos
const DepartmentsPage = Loadable(lazy(() => import('pages/departments')));

// NOVO: Empresa
const CompanyPage = Loadable(lazy(() => import('pages/company')));

// NOVO: Clientes
const ClientsPage = Loadable(lazy(() => import('pages/clients')));
const NewClientPage = Loadable(lazy(() => import('pages/clients/new')));
const ClientDetailsPage = Loadable(lazy(() => import('pages/clients/[id]')));
const EditClientPage = Loadable(lazy(() => import('pages/clients/[id]/edit')));

// NOVO: Projetos
const ProjectsPage = Loadable(lazy(() => import('pages/projects')));

// NOVO: Escopos
const ScopesPage = Loadable(lazy(() => import('pages/scopes')));
const NewScopePage = Loadable(lazy(() => import('pages/scopes/new')));
const ScopeViewPage = Loadable(lazy(() => import('pages/scopes/[id]')));
const EditScopePage = Loadable(lazy(() => import('pages/scopes/[id]/edit')));

// NOVO: Bloqueios de Conta
const AccountBlocksPage = Loadable(lazy(() => import('pages/security/account-blocks')));

// NOVO: Uso da IA
const AiUsagePage = Loadable(lazy(() => import('pages/ai-usage')));
const AiBudgetPage = Loadable(lazy(() => import('pages/ai-budget')));
const MyAiBudgetPage = Loadable(lazy(() => import('pages/my-ai-budget')));

// Pagamentos
const PaymentPackagesPage = Loadable(lazy(() => import('pages/payments/packages')));
const PaymentHistoryPage = Loadable(lazy(() => import('pages/payments/history')));
const PaymentAdminPackagesPage = Loadable(lazy(() => import('pages/payments/admin/packages')));
const PaymentAdminOrdersPage = Loadable(lazy(() => import('pages/payments/admin/orders')));
const PaymentReturnPage = Loadable(lazy(() => import('pages/payments/return')));

// AI Video
const AiVideoPage = Loadable(lazy(() => import('pages/ai-video')));

// AI Chat
const AiChatPage = Loadable(lazy(() => import('pages/ai-chat')));
const AiChatAssistantsListPage = Loadable(lazy(() => import('pages/ai-chat/assistants')));
const AiChatAssistantEditorPage = Loadable(lazy(() => import('pages/ai-chat/assistants/[id]')));

// NOVO: Contratos
const ContractTemplatesPage = Loadable(lazy(() => import('pages/contracts/templates')));
const ContractsPage = Loadable(lazy(() => import('pages/contracts')));
const NewContractPage = Loadable(lazy(() => import('pages/contracts/new')));
const ContractViewPage = Loadable(lazy(() => import('pages/contracts/[id]')));
const EditContractPage = Loadable(lazy(() => import('pages/contracts/[id]/edit')));

// Transcrições
const TranscriptionsPage = Loadable(lazy(() => import('pages/transcriptions')));
const TranscriptionNewPage = Loadable(lazy(() => import('pages/transcriptions/new')));
const TranscriptionDetailPage = Loadable(lazy(() => import('pages/transcriptions/[id]')));

// WhatsApp
const WhatsAppInstancesPage = Loadable(lazy(() => import('pages/whatsapp/instances')));
const WhatsAppInboxPage = Loadable(lazy(() => import('pages/whatsapp/inbox')));
const WhatsAppBillingPage = Loadable(lazy(() => import('pages/whatsapp/billing')));
const WhatsAppAgentInboxPage = Loadable(lazy(() => import('pages/whatsapp/agent-inbox')));
const WhatsAppObservabilityPage = Loadable(lazy(() => import('pages/whatsapp/observability')));
const WhatsAppScheduledPage = Loadable(lazy(() => import('pages/whatsapp/scheduled')));

// Tarefas
const TasksPage = Loadable(lazy(() => import('pages/tasks')));

// Scrum (board da sprint; backlog e sprints acessíveis por /projects/:projectId/...)
const ScrumSprintBoardPage = Loadable(lazy(() => import('pages/scrum/sprints/[sprintId]')));

// NOVO: Cofre de Chaves de Segurança
const SecurityKeysPage = Loadable(lazy(() => import('pages/security-keys')));

// Por projeto (acessíveis pela lista de projetos; layout com abas Dashboard / Backlog / Sprints)
const ProjectManagementLayout = Loadable(lazy(() => import('layout/ProjectManagementLayout')));
const ProjectDashboardPage = Loadable(lazy(() => import('pages/projects/[projectId]/dashboard')));
const ProjectBacklogPage = Loadable(lazy(() => import('pages/projects/[projectId]/backlog')));
const ProjectSprintsPage = Loadable(lazy(() => import('pages/projects/[projectId]/sprints')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: 'devices',
          element: <DevicesCenter />
        },
        // NOVO: Bloqueios de Conta
        {
          path: 'blocks',
          element: <AccountBlocksPage />
        },
        {
          path: 'account',
          element: <AccountSettings />
        },
        {
          path: 'settings/integrations',
          element: <SettingsIntegrationsPage />
        },
        {
          path: 'users',
          element: <UsersPage />
        },
        {
          path: 'roles',
          element: <RolesPage />
        },
        {
          path: 'recorder-test',
          element: <RecorderTestPage />
        },
        {
          path: 'reuniao-ao-vivo',
          element: <LiveMeetingPage />
        },
        {
          path: 'departments',
          element: <DepartmentsPage />
        },
        {
          path: 'company',
          element: <CompanyPage />
        },
        {
          path: 'clients',
          element: <ClientsPage />
        },
        {
          path: 'clients/new',
          element: <NewClientPage />
        },
        {
          path: 'clients/:id',
          element: <ClientDetailsPage />
        },
        {
          path: 'clients/:id/edit',
          element: <EditClientPage />
        },
        {
          path: 'projects',
          element: <ProjectsPage />
        },
        {
          path: 'projects/:projectId',
          element: <ProjectManagementLayout />,
          children: [
            { index: true, element: <Navigate to="backlog" replace /> },
            { path: 'dashboard', element: <ProjectDashboardPage /> },
            { path: 'backlog', element: <ProjectBacklogPage /> },
            { path: 'sprints', element: <ProjectSprintsPage /> }
          ]
        },
        {
          path: 'scopes',
          element: <ScopesPage />
        },
        {
          path: 'scopes/new',
          element: <NewScopePage />
        },
        {
          path: 'scopes/:id',
          element: <ScopeViewPage />
        },
        {
          path: 'scopes/:id/edit',
          element: <EditScopePage />
        },
        {
          path: 'sensitive-fields',
          element: <SensitiveFieldsPage />
        },
        {
          path: 'ai-usage',
          element: <AiUsagePage />
        },
        {
          path: 'ai-budget',
          element: <AiBudgetPage />
        },
        {
          path: 'my-ai-budget',
          element: <MyAiBudgetPage />
        },
        {
          path: 'ai-video',
          element: <AiVideoPage />
        },
        {
          path: 'creditos',
          element: <PaymentPackagesPage />
        },
        {
          path: 'creditos/historico',
          element: <PaymentHistoryPage />
        },
        {
          path: 'admin/pagamentos/pacotes',
          element: <PaymentAdminPackagesPage />
        },
        {
          path: 'admin/pagamentos/pedidos',
          element: <PaymentAdminOrdersPage />
        },
        {
          path: 'pagamento/sucesso',
          element: <PaymentReturnPage />
        },
        {
          path: 'pagamento/falha',
          element: <PaymentReturnPage />
        },
        {
          path: 'pagamento/cancelado',
          element: <PaymentReturnPage />
        },
        {
          path: 'pagamento/pendente',
          element: <PaymentReturnPage />
        },
        {
          path: 'ai-chat/assistants',
          element: <AiChatAssistantsListPage />
        },
        {
          path: 'ai-chat/assistants/:id',
          element: <AiChatAssistantEditorPage />
        },
        {
          path: 'ai-chat',
          element: <AiChatPage />
        },
        // NOVO: Contratos
        {
          path: 'contracts/templates',
          element: <ContractTemplatesPage />
        },
        {
          path: 'contracts/new',
          element: <NewContractPage />
        },
        {
          path: 'contracts/:id',
          element: <ContractViewPage />
        },
        {
          path: 'contracts/:id/edit',
          element: <EditContractPage />
        },
        {
          path: 'contracts',
          element: <ContractsPage />
        },
        {
          path: 'transcriptions',
          element: <TranscriptionsPage />
        },
        {
          path: 'transcriptions/new',
          element: <TranscriptionNewPage />
        },
        {
          path: 'transcriptions/:id',
          element: <TranscriptionDetailPage />
        },
        // Scrum
        {
          path: 'scrum/sprints/:sprintId',
          element: <ScrumSprintBoardPage />
        },
        // Cofre de Chaves
        {
          path: 'security-keys',
          element: <SecurityKeysPage />
        },
        // WhatsApp
        {
          path: 'whatsapp/instances',
          element: <WhatsAppInstancesPage />
        },
        {
          path: 'whatsapp/inbox',
          element: <WhatsAppInboxPage />
        },
        {
          path: 'whatsapp/billing',
          element: <WhatsAppBillingPage />
        },
        {
          path: 'whatsapp/agent-inbox',
          element: <WhatsAppAgentInboxPage />
        },
        {
          path: 'whatsapp/observability',
          element: <WhatsAppObservabilityPage />
        },
        {
          path: 'whatsapp/scheduled',
          element: <WhatsAppScheduledPage />
        },
        {
          path: 'tasks',
          element: <TasksPage />
        }
      ]
    },
    {
      path: '/maintenance',
      element: <PagesLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        },
        {
          path: 'under-construction',
          element: <MaintenanceUnderConstruction />
        },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />
        }
      ]
    }
  ]
};

export default MainRoutes;
